import React from 'react';
import PropTypes from 'prop-types';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Checkbox, Row, Col } from 'antd';

export default class Facilities extends React.Component {
  constructor(props) {
    super(props);
  }

  handleCheckboxChange = checkBoxItem => {
    const { value } = this.props;
    const newFacilities = value?.map(facility => {
      if (facility.checked !== checkBoxItem.value) {
        if (checkBoxItem.slug === facility.slug) {
          if (checkBoxItem.value) {
            return {
              slug: facility.slug,
              label: facility.label,
              checked: true,
            };
          }
          return {
            slug: facility.slug,
            label: facility.label,
            checked: false,
          };
        }
      }
      return facility;
    });
    this.props.onChange(newFacilities);
  };

  render() {
    const { t, value } = this.props;
    return (
      <div className="facilities">
        <div className="content-title">
          <span className="content-title__text">
            {t('cms:cms.properties.edit.rooms.facilities')}
          </span>
        </div>
        <Row gutter={16}>
          <For of={value ?? []} each="checkBoxItem">
            <Col span={12}>
              <Form.Item key={checkBoxItem.slug}>
                <Checkbox
                  onChange={e => {
                    this.handleCheckboxChange({ value: e.target.checked, ...checkBoxItem });
                  }}
                  defaultChecked={checkBoxItem.checked}
                >
                  {checkBoxItem.label}
                </Checkbox>
              </Form.Item>
            </Col>
          </For>
        </Row>
      </div>
    );
  }
}

Facilities.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

Facilities.defaultProps = {
  t: () => {},
  onChange: () => {},
};
